<template>
    <button type="button" class="btn btn-outline-primary"><slot /></button>
</template>